import { useState, useEffect } from 'react';
import { auth } from '../firebase/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ReactComponent as Logo } from '../censuszen-logo.svg';
import '../styles/Auth.css';

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    const successMessage = location.state?.message;

    // Use useEffect for navigation
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/');  // Redirect to home page after successful login
        } catch (error) {
            setError('Failed to log in: ' + error.message);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <Link to="/" className="auth-logo-link">
                    <Logo className="auth-logo" aria-label="CensusZen" />
                </Link>
                <form onSubmit={handleLogin} className="auth-form">
                    <h2 className="auth-title">Welcome back</h2>
                    <p className="auth-subtitle">Sign in to your account</p>
                    {successMessage && <div className="auth-success">{successMessage}</div>}
                    {error && <div className="auth-error">{error}</div>}
                    <div className="auth-field">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="username"
                            placeholder="you@example.com"
                        />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                            placeholder="Enter your password"
                        />
                    </div>
                    <button type="submit" className="auth-submit">Sign In</button>
                    <div className="auth-links">
                        <Link to="/forgot-password">Forgot password?</Link>
                        <Link to="/register">Create account</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};
